import React from 'react';
import { Helmet } from 'react-helmet';

const CommonSEOTitle = ({ title }) => {
  return (
    <Helmet>
      <title>{title} | Technource ERP</title>
    </Helmet>
  );
};

export default CommonSEOTitle;
